<div class="section">
    @if (section.sectionTitle) {
<h3 class="section-title">{{ section.sectionTitle }}</h3>
}

    <div class="section-fields">
        @for (field of section.fields; track field) {
<div class="field-container" [class.hidden]="!shouldShowField(field)"
            [class.full-width]="field.fullWidth || field.fieldType === 'subsection'">

            @if (field.fieldType === 'text') {
<app-textbox [label]="field.fieldLabel"
                [placeholder]="field.placeholder || ''" [control]="getFormControl(field.fieldName)"
                [dataId]="field.fieldName" [required]="field.required">
            </app-textbox>
}

            @if (field.fieldType === 'number') {
<app-textbox [label]="field.fieldLabel"
                [placeholder]="field.placeholder || ''" [control]="getFormControl(field.fieldName)"
                [dataId]="field.fieldName" [required]="field.required" [type]="'number'" [min]="field.min"
                [max]="field.max" [step]="field.step" [decimalSupport]="field.decimalSupport">
            </app-textbox>
}

            @if (field.fieldType === 'password') {
<app-textbox [label]="field.fieldLabel"
                [placeholder]="field.placeholder" [control]="getFormControl(field.fieldName)" [dataId]="field.fieldName"
                [required]="field.required" [type]="'password'">
            </app-textbox>
}

            @if (field.fieldType === 'dropdown') {
<app-dropdown [label]="field.fieldLabel" [dataId]="field.fieldName"
                [placeholder]="field.placeholder" [options]="field.options" [control]="getFormControl(field.fieldName)"
                [required]="field.required">
            </app-dropdown>
}

            @if (field.fieldType === 'radio') {
<app-radio-button-group [label]="field.fieldLabel"
                [dataId]="field.fieldName" [options]="field.options" [control]="getFormControl(field.fieldName)"
                [required]="field.required">
            </app-radio-button-group>
}

            @if (field.fieldType === 'toggle') {
<app-toggle-switch [label]="field.fieldLabel"
                [dataId]="field.fieldName" [control]="getFormControl(field.fieldName)" [required]="field.required">
            </app-toggle-switch>
}

            @if (field.fieldType === 'checkbox') {
<app-checkbox-group [label]="field.fieldLabel"
                [dataId]="field.fieldName" [options]="field.options" [control]="getFormControl(field.fieldName)"
                [required]="field.required">
            </app-checkbox-group>
}

            @if (field.fieldType === 'date') {
<app-date-picker [label]="field.fieldLabel" [dataId]="field.fieldName"
                [control]="getFormControl(field.fieldName)" [required]="field.required">
            </app-date-picker>
}

            <!-- Subsection component -->
            @if (field.fieldType === 'subsection') {
<app-subsection [subsection]="field.subsection"
                [formGroup]="formGroup" [disabled]="disabled" (fieldChange)="onFieldChange($event.field, $event.value)">
            </app-subsection>
}
        </div>
}
    </div>
</div>